/* eslint-disable */ import { AjvReflection, DomainEntityReflection, EnumReflection, RawAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
export const modelVersion = 3;
export const GenericDomainEntity = new AjvReflection('GenericDomainEntity', {
    type: 'object',
    properties: {
        id: {
            type: 'string',
            pattern: '^[A-Z]\\w*-\\d+$'
        },
        type: {
            type: 'string'
        }
    },
    additionalProperties: true,
    required: [
        'id',
        'type'
    ]
});
export const RecipeConfiguration = new AjvReflection('RecipeConfiguration', {
    type: 'object',
    properties: {
        modelVersion: {
            type: 'integer'
        },
        entities: {
            type: 'array',
            items: GenericDomainEntity._meta.schema
        },
        rootEntityType: {
            type: 'string'
        },
        rootRecipeId: {
            type: 'string'
        },
        recipeIds: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        configurationId: {
            type: 'string'
        },
        revisionId: {
            type: 'string'
        },
        ownerToken: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'entities',
        'rootEntityType',
        'rootRecipeId',
        'recipeIds',
        'modelVersion',
        'configurationId',
        'revisionId',
        'ownerToken'
    ]
});
export const Finish = new EnumReflection('Finish', {
    enum: [
        'brushed',
        'milled',
        'chequer',
        'propeller'
    ]
});
export const RawMaterial = new EnumReflection('RawMaterial', {
    enum: [
        'brass',
        'ss304',
        'ss316',
        'aluminium'
    ]
});
export const AnchorPointPosition = new EnumReflection('AnchorPointPosition', {
    enum: [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight',
        'top',
        'bottom',
        'left',
        'right',
        'center'
    ]
});
const CommonAdminEntityShape = new AjvReflection('CommonAdminEntityShape', {
    type: 'object',
    properties: {
        commonAdminModelVersion: {
            enum: [
                3
            ]
        }
    },
    additionalProperties: false,
    required: [
        'commonAdminModelVersion'
    ]
});
const PresetCategoryShape = new AjvReflection('PresetCategoryShape', {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        index: {
            type: 'number'
        },
        visible: {
            type: 'boolean'
        },
        description: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'name',
        'index',
        'visible',
        'description'
    ]
});
const PresetShape = new AjvReflection('PresetShape', {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        index: {
            type: 'number'
        },
        visible: {
            type: 'boolean'
        },
        categoryId: {
            oneOf: [
                {
                    type: 'string',
                    pattern: '^[A-Z]\\w*-\\d+$'
                },
                {
                    type: 'null'
                }
            ]
        },
        configurationId: {
            type: [
                'string',
                'null'
            ]
        },
        revisionId: {
            type: [
                'string',
                'null'
            ]
        },
        ownerToken: {
            type: [
                'string',
                'null'
            ]
        },
        readToken: {
            type: [
                'string',
                'null'
            ]
        },
        thumbnailUrl: {
            type: [
                'string',
                'null'
            ]
        },
        tags: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    additionalProperties: false,
    required: [
        'name',
        'description',
        'index',
        'visible',
        'categoryId',
        'configurationId',
        'revisionId',
        'ownerToken',
        'readToken',
        'thumbnailUrl',
        'tags'
    ]
});
const RecipeShape = new AjvReflection('RecipeShape', {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        collection: {
            type: 'string'
        },
        index: {
            type: 'number'
        },
        visible: {
            type: 'boolean'
        },
        configuration: {
            anyOf: [
                RecipeConfiguration._meta.schema,
                {
                    type: 'null'
                }
            ]
        }
    },
    additionalProperties: false,
    required: [
        'name',
        'description',
        'collection',
        'index',
        'visible',
        'configuration'
    ]
});
const CustomMaterialShape = new AjvReflection('CustomMaterialShape', {
    type: 'object',
    properties: {
        code: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        length: {
            type: 'number'
        },
        width: {
            type: 'number'
        },
        thickness: {
            type: 'number'
        },
        rawMaterial: RawMaterial._meta.schema,
        finish: Finish._meta.schema,
        visible: {
            type: 'boolean'
        },
        standard: {
            type: 'boolean'
        }
    },
    additionalProperties: false,
    required: [
        'code',
        'name',
        'length',
        'width',
        'thickness',
        'rawMaterial',
        'finish',
        'visible',
        'standard'
    ]
});
const CountersinkShape = new AjvReflection('CountersinkShape', {
    type: 'object',
    properties: {
        topRadius: {
            type: 'number'
        },
        bottomRadius: {
            type: 'number'
        },
        plateThicknessMin: {
            type: 'number'
        },
        plateThicknessMax: {
            type: 'number'
        },
        visible: {
            type: 'boolean'
        }
    },
    additionalProperties: false,
    required: [
        'topRadius',
        'bottomRadius',
        'plateThicknessMin',
        'plateThicknessMax',
        'visible'
    ]
});
const FeatureSettingShape = new AjvReflection('FeatureSettingShape', {
    type: 'object',
    properties: {
        plateType: {
            type: 'string'
        },
        featureType: {
            type: 'string'
        },
        offsetX: {
            type: 'number'
        },
        offsetY: {
            type: 'number'
        },
        anchorPointPosition: AnchorPointPosition._meta.schema
    },
    additionalProperties: false,
    required: [
        'plateType',
        'featureType',
        'offsetX',
        'offsetY',
        'anchorPointPosition'
    ]
});
export const Admin = new DomainEntityReflection('Admin', [
    CommonAdminEntityShape._meta.schema
]);
export const Preset = new DomainEntityReflection('Preset', [
    PresetShape._meta.schema,
    CommonAdminEntityShape._meta.schema
]);
export const PresetCategory = new DomainEntityReflection('PresetCategory', [
    PresetCategoryShape._meta.schema,
    CommonAdminEntityShape._meta.schema
]);
export const Recipe = new DomainEntityReflection('Recipe', [
    RecipeShape._meta.schema,
    CommonAdminEntityShape._meta.schema
]);
export const DummyDoNotUse = new DomainEntityReflection('DummyDoNotUse', []);
export const CustomMaterial = new DomainEntityReflection('CustomMaterial', [
    CustomMaterialShape._meta.schema
]);
export const Countersink = new DomainEntityReflection('Countersink', [
    CountersinkShape._meta.schema
]);
export const FeatureSetting = new DomainEntityReflection('FeatureSetting', [
    FeatureSettingShape._meta.schema
]);
export const AnyDomainEntity = new RawAliasReflection('AnyDomainEntity', [
    Admin,
    Preset,
    PresetCategory,
    Recipe,
    DummyDoNotUse,
    CustomMaterial,
    Countersink,
    FeatureSetting
]);
export const RootEntity = new RawAliasReflection('RootEntity', [
    Admin
]);
export const CommonAdminEntity = new RawAliasReflection('CommonAdminEntity', [
    Admin,
    Preset,
    PresetCategory,
    Recipe
]);
export const aliases = {
    AnyDomainEntity: AnyDomainEntity.types,
    RootEntity: RootEntity.types,
    CommonAdminEntity: CommonAdminEntity.types
};
export const entities = {
    Admin,
    Preset,
    PresetCategory,
    Recipe,
    DummyDoNotUse,
    CustomMaterial,
    Countersink,
    FeatureSetting
};

//# sourceMappingURL=v3.js.map